import { connect } from 'react-redux';
import { useEffect } from 'react';
import PropTypes from 'prop-types';
import styles from './view-result-button.module.scss';
import BsButton from 'react-bootstrap/Button';
import { augmentClassName } from '../../../../utils/GlobalCssProxy';

const className = augmentClassName(styles);

export const ViewResultButton = ({
  resultData,
  viewResult,
  collapsePresetCategory,
  showOnlyMyHoldings
}) => {
  const numResults = showOnlyMyHoldings ? resultData.ownedResultsCount : resultData.totalResults;

  useEffect(() => {
    if (!collapsePresetCategory || !resultData) {
      return;
    }
    collapsePresetCategory();
  }, []);


  return (
    <BsButton
      {...className('btn-results')}
      /* TIAA Analytics Tracking */
      id="InvestmentScreenerViewResults"
      data-analytics-linkname={`View ${numResults || ''} results`}
      data-analytics-section="component"
      data-analytics-componenttype="JumpNav"
      /* END TIAA Analytics Tracking */
      variant="outline-secondary"
      size="md"
      onClick={viewResult}>
      View {numResults} Results
    </BsButton>
  );
};

ViewResultButton.propTypes = {
  resultData: PropTypes.object,
  viewResult: PropTypes.func,
  collapsePresetCategory: PropTypes.func,
  showOnlyMyHoldings: PropTypes.bool
};

const mapStateToProps = state => {
  return {
    resultData: state.resultData,
    showOnlyMyHoldings: state.filterReducer.toggles.showOnlyMyHoldings
  };
};

export default connect(mapStateToProps, null)(ViewResultButton);
